<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <teleport to="#notification-overlay">
    <div
      aria-live="assertive"
      status="padding-bottom: max(env(safe-area-inset-bottom, 1.5rem), 1.5rem);"
      class="fixed inset-0 flex items-end px-4 pt-6 mb-20 pointer-events-none z-100"
    >
      <div class="w-full flex flex-col items-center space-y-4">
        <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
        <transition
          v-for="notification of visibleNotifications" :key="notification.id"
          enter-active-class="transform ease-out duration-300 transition"
          enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
          leave-active-class="transition ease-in duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div class="max-w-sm w-full bg-gray-800 shadow-lg rounded pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
            <div class="p-4">
              <div class="flex items-center">
                <div class="w-0 flex-1 flex justify-between">
                  <p class="w-0 flex-1 text-sm font-medium text-white">
                    {{ notification.message }}
                  </p>
                </div>
                <div class="ml-4 flex-shrink-0 flex">
                  <button v-if="showClose" @click="show = false" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    <span class="sr-only">Schließen</span>
                    <XMarkIcon class="h-5 w-5" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </teleport>
</template>


<script lang="ts">
  import { ref, defineComponent } from 'vue'
  import { XMarkIcon } from '@heroicons/vue/24/solid'

  import { notifications } from '../../globals/notifications';


  export default defineComponent({
    props: {
      showClose: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        now: new Date(),
        interval: undefined as undefined|NodeJS.Timeout,
      }
    },
    components: {
      XMarkIcon,
    },
    setup() {
      const show = ref(true)

      return {
        notifications,
        show,
      }
    },
    computed: {
      visibleNotifications() {
        return this.notifications.notifications.value
          .filter(notification => notification.showUntil > this.now)
          .slice(-4);
      },
    },
    mounted() {
      this.interval = setInterval(() => {
        this.now = new Date();
      }, 250);
    },
    unmounted() {
      if (this.interval) clearInterval(this.interval);
    },
  })
</script>
